import React, { useRef, useState } from 'react';
import Icon, { COLORS, ICONS } from '../general-components/icon';
import Dialog from '../general-components/dialog';
import UploadProgressIndicator from './upload-progress-indicator';
import { UploadInterface, useGetProgressByIdentifier } from '../../contexts/upload-context';

interface Props {
	uploadingItem: UploadInterface;
	cancelUpload?: (e: any, uploadingItem: UploadInterface, id: string) => void;
	id?: string;
}

export default function UploadingLink({ uploadingItem, cancelUpload, id }: Props) {
	const {
		uploadName,
		uploadRequest,
		uploadIdentifier,
	} = uploadingItem;

	const [cancelButtonX, setCancelButtonX] = useState<number | undefined>();
	const [cancelButtonY, setCancelButtonY] = useState<number | undefined>();
	const cancelButtonRef = useRef<HTMLDivElement | null>(null);
	const dialog = useRef<any>(null);

	const progress = useGetProgressByIdentifier(uploadIdentifier);

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const dialogCallback = (confirmed: boolean, cancelled: boolean) => {
		// eslint-disable-next-line no-unused-expressions
		confirmed && uploadRequest.abort();
	};

	const showCancelUploadDialog = (e: any) => {
		if (cancelUpload) {
			cancelUpload(e, uploadingItem, id ?? '');
			return;
		}

		setCancelButtonX(
			cancelButtonRef.current
				? (cancelButtonRef.current?.getBoundingClientRect().left ?? 0) - 433
				: undefined,
		);
		setCancelButtonY(
			cancelButtonRef.current
				? (cancelButtonRef.current?.getBoundingClientRect().top ?? 0) - 65
				: undefined,
		);
		dialog.current.confirm('Are you sure you want to cancel this upload?', '', 'Yes', 'No', dialogCallback);
		e.stopPropagation();
	};

	return (
		<>
			<div
				className="padding-top-small"
				onFocus={(e) => e.currentTarget.blur()}
			>
				<div className="media-link" id={id}>
					<div className="thumbnail">
						<UploadProgressIndicator progress={progress} />
					</div>
					<div className="media-details">
						<div className="media-details-metadata uploading">
							<p className="media-title bl-font-s3">{uploadName}</p>
							<p className='media-description bl-font-c2'>Uploading...</p>
						</div>
						<div ref={cancelButtonRef} className='delete-btn media-dots-wrap' onClick={showCancelUploadDialog}>
							<Icon name={ICONS.TRASH} color={COLORS.GRAY} size={16}></Icon>
						</div>
					</div>
				</div>
			</div>
			<Dialog
				ref={dialog}
				xPixel={cancelButtonX}
				yPixel={cancelButtonY}
			/>
		</>
	);
}
